import { render, staticRenderFns } from "./LimitPriceField.vue?vue&type=template&id=395d7818&scoped=true"
import script from "./LimitPriceField.vue?vue&type=script&lang=js"
export * from "./LimitPriceField.vue?vue&type=script&lang=js"
import style0 from "./LimitPriceField.vue?vue&type=style&index=0&id=395d7818&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d7818",
  null
  
)

export default component.exports